<template lang="pug">
#menuFlag
  .nav(:class="whether ? 'scrolling' : ''")
    .nav-content
      .item-left
        img.logo(src='@/assets/imgs/logo.png')
      .item-right
        a.tab(:href='fanyiUrl' target="_blank") 有道翻译桌面端
        a.tab(href="https://fanyi.youdao.com/index.html#/?keyfrom=cidian" target="_blank") 有道翻译网页版
        a.tab(href="https://fanyi.youdao.com/enterprise" target="_blank") 有道翻译企业版
        a.tab.active(@click="goHome") 有道翻译超级会员
        a.tab(:href='cidianUrl' target="_blank") 有道词典APP
</template>
x``
<script>
export default {
  name: '',
  data() {
    return {
      whether: false,
      fanyiUrl: `${process.env.VUE_APP_FANYI_DOWNLOAD_URL}/download`,
      cidianUrl: `${process.env.VUE_APP_BASE_URL}/download-app/`,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 计算滚动条位置
      const scrollTop = window.pageYOffset
        || document.documentElement.scrollTop
        || document.body.scrollTop;
      // 计算绑定div位置
      const { offsetTop } = document.querySelector('#menuFlag');
      // 进行比较设置位置fixed
      this.whether = scrollTop > offsetTop;
    },
    goHome() {
      this.$router.push({ path: '/', query: { ...this.$route.query } });
    },
  },
};
</script>

<style lang="stylus" scoped>
.scrolling
  background: hsla(0,0%,100%,.81)
  -webkit-backdrop-filter blur(15px)
  backdrop-filter blur(15px)
  box-shadow 0px 5px 15px rgba(0, 0, 0, 0.05)
#menuFlag
  height 70px
.nav
  width 100%
  height 70px
  display -ms-flexbox
  display flex
  -ms-flex-align center
  align-items center
  position fixed
  top 0
  left 0
  z-index 999
  .nav-content
    width 1200px
    margin 0 auto
    display -ms-flexbox
    display flex
    -ms-flex-pack justify
    justify-content space-between
    .item-left
      .logo
        width 164px
        height auto
    .item-right
      display flex
      font-family 'PingFang SC'
      font-style normal
      font-weight 500
      font-size 18px
      line-height 35px
      .active
        color #E8493F
      .tab
        padding-left 75px
        cursor pointer
</style>
